import { Divider } from "@mui/material";
import { FC } from "react";
import {
  List,
  ListItem,
  ListItemSecondaryAction,
} from "@mui/material";
import { H4 } from "../components/Typography";

interface ReturnInformationProps {
  item: {
    label: string;
    value: any;
    data?: { name: string; value: any }[];
    amc_code: string;
    amc_name: string;
  };
}
const AmcInformation: FC<ReturnInformationProps> = ({ item }) => {
  const data = [
    {
      name: "AMC Name",
      value: item?.amc_name ?? "",
    },
    {
      name: "AMC Code",
      value: item?.amc_code ?? "",
    },
  ];

  return (
    <>
      <List>
        {data?.map((data, index) => (
          <>
            <ListItem
              disableGutters
              sx={{
                display: "flex",
                justifyContent: "space-between",
                py: 0.5,
                px: 2,
                pl: 2,
                pt: 1,
                pb: 1,
                background: "#fff",
              }}
            >
              <H4 sx={{ minWidth: "50%" }}>{data.name}</H4>
              <ListItemSecondaryAction>
                <H4 sx={{ minWidth: "50%", mr: 2 }}>{data.value}</H4>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider />
          </>
        ))}
      </List>
    </>
  );
};

export default AmcInformation;
